import axios from 'axios';
import environment from '../../../environment';
import Cookies from 'js-cookie';

function ContactWhatsapp() {
  var urltemp = new URL(window.location.href);
  let utm_cookie = {}
  if (Cookies.get('utm')) {
    utm_cookie = JSON.parse(Cookies.get('utm'));
    urltemp.searchParams.append('utm_source', utm_cookie.utm_source);
    urltemp.searchParams.set('utm_medium', utm_cookie.utm_medium);
    urltemp.searchParams.set('utm_campaign', utm_cookie.utm_campaign);
  }
  const url = `https://api.whatsapp.com/send/?phone=${environment.NUMBER_WHATSAPP}&text=Buenos%20días.%20Solicito%20información%20sobre%20la%20propiedad%20${encodeURIComponent(urltemp.toString())}`;

  const saveEvent = async () => {
    try{
      const { data } = await axios.post(`${environment.ENDPOINT_CAPIRENTBACKEND}/event/add`, {
        category: 'Botón Whatsapp',
        action: 'Click',
        data: {}
      });
    } 
    catch(error) {

    }
  }

  return (
    <div className="pb-4 px-4">
      <div>
        <div className="d-flex justify-content-center">
          <button 
            type="button" 
            className="form-button py-2 microcopy-bold text-white btn w-75"
            onClick={() => {
              saveEvent();
              window.open(url, "_blank", "noreferrer")
            }}
          >
            Enviar WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContactWhatsapp;